import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { IMAGE_QUERY_PARAMS } from '../../constants/constants.js';
import { useGetOrderByToken } from '../../hooks/getOrderByToken/use-get-order-by-token.js';
import { toCustomerDetails, toAddress, toOrderDeliveryMethod, toOrderDetailsPaymentInfo, toInvoice, toServiceStore, toOrderDetailPrice } from '../../mappers/orders.js';
import { toOrderLineItem } from '../../mappers/line-item/order-line-item.js';
import { getShipmentStatusLabel } from '../../mappers/utils/get-shipment-status-label.js';
import { getPaymentMethodLabel } from '../../mappers/utils/get-payment-method-label.js';
import { getPaymentStatusLabel } from '../../mappers/utils/get-payment-status-label.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import { OrderContext } from './context.js';

const OrderProvider = ({ children  })=>{
    const [getOrderByToken, { called , loading , data , error  }, onCompleted] = useGetOrderByToken();
    const intl = useIntl();
    const options = React.useMemo(()=>({
            imageQueryParams: IMAGE_QUERY_PARAMS
        })
    , []);
    const order1 = React.useMemo(()=>{
        if (data === null) {
            return null;
        }
        if (!data) {
            return undefined;
        }
        const order = data.getOrderByToken;
        var _loyaltyDetails, _receiptUrl, _shipmentTrackingURL;
        return swcHelpers.objectSpread({
            loyaltyDetails: (_loyaltyDetails = order.loyaltyDetails) !== null && _loyaltyDetails !== void 0 ? _loyaltyDetails : undefined,
            customerDetails: toCustomerDetails(order.customerDetails),
            billingAddress: toAddress(order.billingAddress),
            deliveryMethod: toOrderDeliveryMethod(order.shippingInfo),
            lineItems: order.lineItems.map((lineItem)=>toOrderLineItem(lineItem, intl, options)
            ),
            rawLineItems: order.lineItems.map((item)=>item
            ),
            orderDate: new Date(order.orderDate),
            orderNumber: order.orderNumber,
            paymentMethod: getPaymentMethodLabel(order.paymentMethod, intl),
            paymentDetails: toOrderDetailsPaymentInfo(order.payments),
            paymentStatus: getPaymentStatusLabel(order.paymentStatus, intl),
            receiptUrl: (_receiptUrl = order.receiptUrl) !== null && _receiptUrl !== void 0 ? _receiptUrl : undefined,
            shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl),
            shipmentTrackingUrl: (_shipmentTrackingURL = order.shipmentTrackingURL) !== null && _shipmentTrackingURL !== void 0 ? _shipmentTrackingURL : undefined,
            shippingAddress: toAddress(order.shippingAddress),
            invoice: toInvoice(order.invoiceDetails),
            serviceStore: toServiceStore(order.serviceStore)
        }, toOrderDetailPrice(order.price), {
            discountCodes: order.discountCodes || []
        });
    }, [
        data,
        intl,
        options
    ]);
    const value = React.useMemo(()=>({
            order: order1,
            loading,
            error,
            called,
            getOrderByToken,
            onCompleted
        })
    , [
        order1,
        loading,
        error,
        called,
        getOrderByToken,
        onCompleted
    ]);
    if (typeof children === 'function') {
        return /*#__PURE__*/ React.createElement(OrderContext.Provider, {
            value: value
        }, children(value));
    }
    return /*#__PURE__*/ React.createElement(OrderContext.Provider, {
        value: value
    }, children);
};

export { OrderProvider };
//# sourceMappingURL=provider.js.map
